import React from "react";
import UnifiedInboxMessagingPage from "./UnifiedInboxMessagingPage";

export default function EmailInboxPage() {
  return (
    <UnifiedInboxMessagingPage
      initialChannel="email"
      channelLocked
      title="Email Inbox"
      eyebrow="Email Queue"
      description="Review inbound email threads, keep inquiry linkage visible, and manage follow-ups from the same operational workspace."
    />
  );
}
